// extracted by mini-css-extract-plugin
module.exports = {"storeDiv":"styles-module--storeDiv--1B4Ku"};